export default {
  name: "StatisticsLine",
  props: ["chartData"]
};



// WEBPACK FOOTER //
// ./src/components/_charts/chart-types/statistics-line/statistics-line.js